"use strict";

import Debounce from './debounce';
import productQtyInputCalculateEstimate from './productQtyInputCalculateEstimate';
import fetchProductPricing from './fetchProductPricing';

export default ProductEstimate;

function ProductEstimate(el, onChangeCallback, pricing){
    this.el = el || null;
    this.productId = '';
    this.pricing = pricing || [];
    this.estimate = 0;
    this.eventListenerType = 'change';
    this.onChangeCallback = onChangeCallback || function(){};
    this.init();
}

ProductEstimate.prototype = {
    init: function(){
        if(this.el !== null){
            this.productId = this.el.getAttribute('data-pid');
            if(this.el.type === 'text'){
                this.eventListenerType = 'keyup';
                this.fetchProductPricingOnInputFocus();
                if(this.el.value > 0)
                    this.triggerChangeEvent();
            }
            else if(this.el.type === 'select-one'){
                //this.resetProductPricingSelectListOnFocus();// this will force a change event even if selecting same option
                this.triggerChangeEvent(); // force a change event so estimates with initial "unchanged" value
            }
            this.listenForQtyInputChange();
        }
    },
    fetchProductPricingOnInputFocus: function(){
            var self = this;
            this.el.addEventListener('focus', function(e) {
                if(self.pricing.length < 1) {
                    fetchProductPricing(self.productId, function(pricing){
                        if(pricing)
                            self.pricing = pricing;
                    });
                }
            }, false);
    },
    resetProductPricingSelectListOnFocus: function(){
        var self = this;
        this.el.addEventListener('focus', function(e) {
            e.target.selectedIndex=-1;
            e.target.blur();
            self.calculateEstimate();
            self.onChange();
        }, false);
    },
    listenForQtyInputChange: function(){
        var self = this;
        this.el.addEventListener(this.eventListenerType, Debounce(function(e) {
            self.triggerChangeEvent();
        }, 300), false);
    },
    triggerChangeEvent: function(){
        this.calculateEstimate();
        this.onChange();
    },
    calculateEstimate: function(){
        this.estimate = productQtyInputCalculateEstimate(this.el, this.pricing);
    },
    onChange: function(){
        if(typeof(this.onChangeCallback) === 'function')
            this.onChangeCallback(this.el, this.estimate);
    }
};
